(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvNavigationList', drvNavigationList);

    drvNavigationList.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvNavigationList
     * 
     * @description
     * A list control used to show a list of items which can be navigated, e.g. system settings.
     * The will show a search field if 'searchProperties' is populated and will conduct client side filtering.
     * 
     * # Scope Properties
     * {array} items - Array of items (objects) which are to be displayed in a list
     *      Expected format for item (object), refer to NavigationListViewModel.cs:
     *          {string} Name
     *          {string} Label - If supplied this will be used instead of Name when showing on the list. Optional.
     *          {string} Description - Optional.
     *          {string} Icon - Name of an SVG icon. Optional.
     *          {string} IconColour - The colour for the icon. Optional.
     *          {string} IconUsage - The icons usage, e.g. 'document template', 'entity template'. Optional.
     *          {string} Error - Optional.
     *          {int} Count - Count of items belonging to the navigation list item. E.g. number of entities for an entity template. Optional.
     * {function} linkReference - Callback which is expected to return a link reference (string) for the supplied item.
     * {string} searchLabel - Label for the search field
     * {string} titleLabel - Text to be shown in the title bar
     * {string} titleIcon - Icon to be used in the title bar
     * {string} titleIconUsage - Icon usage to be used in the title bar
     */
    function drvNavigationList() {
        var directive = {
            link: link,
            controller: drvNavigationListCtrl,
            restrict: 'E',
            scope: {
                items: '<',
                linkReference: '=',
                searchLabel: '<',
                titleLabel: '<',
                titleIcon: '<?',
                titleIconUsage: '<?'
            },
            template:
                '<div>' +
                '   <drv-title-bar title-text="titleLabel"' +
                '                  title-icon="titleIcon"' +
                '                  title-icon-usage="titleIconUsage"' +
                '                  close-on-click="close()"' +
                '                  hide-menu-bar="true">' +
                '       <button-bar>' +
                '       </button-bar>' +
                '       <menu-bar>' +
                '       </menu-bar>' +
                '   </drv-title-bar>' +
                '</div>' +
                '<div class="page-content">' +
                '   <drv-search-box flex=""' +
                '                   title="searchLabel"' +
                '                   placeholder="searchLabel"' +
                '                   search-text="searchText">' +
                '   </drv-search-box>' +
                '   <md-list class="view-list" layout="row" layout-wrap>' +
                '       <md-list-item flex="100" class="md-2-line" ng-href="{{linkReference(item)}}" ng-repeat="item in filteredItems">' +
                '           <div class="md-list-item-text">' +
                '               <p class="list-item-name"><drv-icon usage="item.IconUsage" icon="item.Icon" colour="item.IconColour"></drv-icon> {{item.Label ? item.Label : item.Name}}<span class="navigation-list-count" ng-if="item.Count !== null">{{item.Count}}</span><span ng-if="item.Error" style="color: red;"> - {{item.Error}}</span></p>' +
                '               <p class="list-item-description" style="margin-left:28px;">{{item.Description}}</p>' +
                '           </div>' +
                '           <md-divider></md-divider>' +
                '       </md-list-item>' +
                '   </md-list>' +
                '</div>'
        };

        drvNavigationListCtrl.$inject = ['$scope', 'NavigationAidService'];

        return directive;

        function drvNavigationListCtrl($scope, NavigationAidService) {
            $scope.close = function () {
                NavigationAidService.goBack();
            };
        }

        function link(scope, element, attrs) {
            scope.getIconColour = getIconColour;
            Object.defineProperty(scope, 'filteredItems', { get: getFilteredItems });

            /*
             * Get the icon colour for the supplied item
             * @returns {string} Colour for icon
             */
            function getIconColour(item) {
                var iconColour = 'grey';

                if (!_.isNil(item.IconColour) && item.IconColour !== '') {
                    iconColour = item.IconColour;
                }

                return iconColour;
            }

            /*
             * Get the list of items which have been filtered by the search text
             * @returns {array} list of items
             */
            function getFilteredItems() {
                var result = scope.items;

                if (!_.isNil(scope.searchText) && scope.searchText !== '') {
                    result = _.filter(scope.items, function (item) {
                        return (!_.isNil(item.Name) && item.Name.toLowerCase().includes(scope.searchText.toLowerCase())) ||
                            (!_.isNil(item.Description) && item.Description.toLowerCase().includes(scope.searchText.toLowerCase()));
                    });
                }

                return result;
            }
        }
    }
})();